import { InspectionCase } from './inspection-case.dto';

export class InspectionWaterNetworkCaseDto extends InspectionCase {
  testerName?: string;
  testDateTime?: Date;
  pressureMeasurementLocation?: string;
  flowMeasurementLocation?: string;
  waterSupplyPipeDiameter?: number;
  staticPressure?: number; // psi
  residualPressure?: number; // psi
  flowRate?: number; // gpm
  systemFlow?: number; // gpm
  systemDemand?: number; // psi
  type?: string;
}

export class InspectionWaterNetworkCase extends InspectionWaterNetworkCaseDto {
  constructor(
    data: InspectionWaterNetworkCaseDto = { isApplicable: true, isPassed: true }
  ) {
    super(data);
    this.title = 'בדיקת אופיין רשת מים';
    this.testerName = data.testerName;
    this.testDateTime = data.testDateTime;
    this.pressureMeasurementLocation = data.pressureMeasurementLocation;
    this.flowMeasurementLocation = data.flowMeasurementLocation;
    this.waterSupplyPipeDiameter = data.waterSupplyPipeDiameter;
    this.staticPressure = data.staticPressure;
    this.residualPressure = data.residualPressure;
    this.flowRate = data.flowRate;
    this.systemFlow = data.systemFlow;
    this.systemDemand = data.systemDemand;
    this.type = data.type;
  }
}
